import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import qs from 'query-string';
import { fetchWebsite } from 'website/website.actions';
import { fetchCities, queryChange } from 'listing/listing.actions';
import websiteReducer from 'website/website.reducer';
import listingReducer from 'listing/listing.reducer';
import citiesReducer from 'website/cities.reducer';
import App from 'containers/App.container';

import { getRoute } from 'routes';

const history = createHistory();
const routerMiddlewareInstance = routerMiddleware(history);

const reducer = combineReducers({
  website: websiteReducer,
  listings: listingReducer,
  cities: citiesReducer,
  router: routerReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk, routerMiddlewareInstance)));

class Root extends Component {
  constructor(props) {
    super(props);

    const query = qs.parse(window.location.search);

    const route = getRoute(window.location);
    if (route) {
      route.init(store, query);
    }

    store
      .dispatch(fetchWebsite())
      .catch(error => console.error("error", error));

    store.dispatch(fetchCities());
    store.dispatch(queryChange(query));

    window.appStore = store;
  }

  render() {
    return (
      <Provider store={store}>
        <App history={history}/>
      </Provider>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root.js